export const widthStyle = "lg:w-[95%] mx-auto mt-[6.5rem] ";
